import { __awaiter, __generator } from "tslib";
export default [
    {
        id: '@mc-permission-distribute',
        path: '/mc-permission-distribute',
        ref: '/',
        onload: function () { return import('./Main'); },
        onbefore: function (app) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2];
            });
        }); },
    },
    {
        point: '@@layers',
        prefix: '@mc-permission-distribute',
        onload: function () { return require('./layers').default; },
    },
];
